<span
  *ngFor="let _ of listOfUnit; let i = index"
  [class.ant-tree-indent-unit]="!nzSelectMode"
  [class.ant-select-tree-indent-unit-start]="nzSelectMode && nzIsStart[i]"
  [class.ant-select-tree-indent-unit]="nzSelectMode"
  [class.ant-tree-indent-unit-start]="!nzSelectMode && nzIsStart[i]"
  [class.ant-select-tree-indent-unit-end]="nzSelectMode && nzIsEnd[i]"
  [class.ant-tree-indent-unit-end]="!nzSelectMode && nzIsEnd[i]"></span>
